import React from 'react';
import { Byline, Heading, StyledCaption, Subheading } from './Caption.styles';
import { SIZE } from '../../../typography/PlayText/PlayText';

type Props = {
    byline?: string;
    heading?: string;
    subHeading?: string;
};

const Caption = ({ byline, heading, subHeading }: Props): JSX.Element => (
    <StyledCaption>
        {byline && (
            <Byline type="medium" as="span">
                {byline}
            </Byline>
        )}
        {heading && <Heading as="h3">{heading}</Heading>}

        {subHeading && <Subheading size={SIZE.LARGE}>{subHeading}</Subheading>}
    </StyledCaption>
);

export default Caption;
